/**
 * @description 全局Model askInfoModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import history from '@src/common/history';

// import * as models from '@services/model/models';
import {
  APIS,
  ParamsquestionQuestionIdCollectUsingPost,
  ParamsquestionQuestionIdUsingGet,
  QuestionInfo,
  CommonResultQuestionInfo,
  ParamsquestionUsingPost,
  QuestionVO,
  ParamsBodyshopPostIncentivesUsingPost,
  CommonResult
} from '@src/services';
import { TkitUtils as Utils } from '@tkit/types';
import { Modal, message } from 'antd';

export interface State {
  askInfoModel: {
    questionInfo: QuestionInfo;
  };
  askInfoAskLoad: boolean;
}

export const askInfoModelState: State = {
  askInfoModel: {
    questionInfo: {}
  },
  askInfoAskLoad: true
};

const model = createModel({
  state: askInfoModelState,
  namespace: 'askInfoModel',
  reducers: {
    setQuestionInfo: (state, action: Tction<{ questionInfo: QuestionInfo }>) => {
      return {
        ...state,
        askInfoModel: {
          ...state.askInfoModel,
          questionInfo: action.payload.questionInfo
        }
      };
    },
    setQuestionFollowInfo: (state, action: Tction<{ hasFollow: boolean }>) => {
      return {
        ...state,
        askInfoModel: {
          ...state.askInfoModel,
          questionInfo: {
            ...state.askInfoModel.questionInfo,
            hasFollow: action.payload.hasFollow
          }
        }
      };
    },
    setQuestionAdoptInfo: (state, action: Tction<{ hasAdoptAnswer: boolean }>) => {
      return {
        ...state,
        askInfoModel: {
          ...state.askInfoModel,
          questionInfo: {
            ...state.askInfoModel.questionInfo,
            hasAdoptAnswer: action.payload.hasAdoptAnswer
          }
        }
      };
    },
    /**
     * @description 设置问题详情loading
     */
    setAskLoad: (state, action: Tction<boolean>) => {
      return {
        ...state,
        askInfoAskLoad: action.payload
      };
    }
  },
  effects: {
    /**
     * @description 根据id获取问题详情
     */
    *getQuestionById(
      { tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdUsingGet;
        callback: (res: CommonResultQuestionInfo) => void;
      }>
    ): Iterator<{}, any, any> {
      const data: Utils.GetROA<typeof APIS.QuestionApi.questionQuestionIdUsingGet> = yield tCall(
        APIS.QuestionApi.questionQuestionIdUsingGet,
        action.payload.params
      );
      if (data.code !== 0) {
        history.replace(`/common/error-handle-page`);
        return;
      } else {
        yield tPut(model.actions.setQuestionInfo, { questionInfo: data.result || {} });
        yield tPut(model.actions.setAskLoad, false);
        action.payload.callback(data);
      }
    },
    *doFollowQuestion(
      { tPut, tCall },
      action: Tction<{ params: ParamsquestionQuestionIdCollectUsingPost }>
    ): Iterator<{}, any, any> {
      const data: Utils.GetROA<typeof APIS.QuestionApi.questionQuestionIdCollectUsingPost> = yield tCall(
        APIS.QuestionApi.questionQuestionIdCollectUsingPost,
        action.payload.params
      );
      if (data.code === 0) {
        yield tPut(model.actions.setQuestionFollowInfo, { hasFollow: action.payload.params.type });
      }
    },
    *doChangeQuestionAdoptInfo(
      { tPut },
      action: Tction<{
        hasAdoptAnswer: boolean;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.setQuestionAdoptInfo, {
        hasAdoptAnswer: action.payload.hasAdoptAnswer
      });
    },
    /** 发布问题 */
    *publishQuestion(
      { tPut, tCall },
      action: Tction<{
        params: ParamsquestionUsingPost;
        data: QuestionVO;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, data, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.QuestionApi.questionUsingPost> = yield tCall(
        APIS.QuestionApi.questionUsingPost,
        params,
        data
      );
      if (res.code === 0) {
        callback(res);
      } else {
        Modal.error({
          title: res.message,
          content: null,
          centered: true
        });
      }
    },
    *deleteAsk(
      { tPut, tCall },
      action: Tction<{ params: { questionId: number } }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.AdminApi.deleteQuestion> = yield tCall(
        APIS.AdminApi.deleteQuestion,
        params
      );
      const { code } = res;
      if (code === 0) {
        message.success('删除成功');
        return true;
      } else {
        message.error(res.message);
        return false;
      }
    }
  }
});

export default model;
